import { Config } from '@sternum/web/config';

export class LocalStorage<T> {
  private oldVersions = ['sternum_ads_'];
  // TODO: when you update prefix values please update also token in cypress config - web/cypress/trpc.ts
  static DEFAULT_LS_PREFIX = Config.useMockServer ? '__sternum_ads_mock_' : 'sternum_storage_1_';

  constructor(private _prefix?: string) {
    this.removeOldVersions();
  }

  get prefix() {
    return this._prefix || LocalStorage.DEFAULT_LS_PREFIX;
  }

  protected get<KeyType extends keyof T>(key: KeyType): T[KeyType] | undefined {
    try {
      const item = localStorage.getItem(this.prefix + (key as string));

      if (item === null) return undefined;

      return JSON.parse(item) as unknown as T[KeyType];
    } catch {
      return undefined;
    }
  }

  protected set<KeyType extends keyof T>(key: KeyType, value: T[KeyType]): void {
    const stringifyValue = JSON.stringify(value);

    localStorage.setItem(this.prefix + (key as string), stringifyValue);
  }

  protected remove<KeyType extends keyof T>(key: KeyType): void {
    return localStorage.removeItem(this.prefix + (key as string));
  }

  private removeOldVersions() {
    Object.keys(localStorage).forEach((key) => {
      const isOldVersionKey = this.oldVersions.some((oldVersion) => key.includes(oldVersion));

      if (isOldVersionKey) {
        localStorage.removeItem(key);
      }
    });
  }
}
